import { Box, Button, Center, Wrap, WrapItem } from "@chakra-ui/react";
import React from "react";
import { MaterialIcon } from "../../../components/shared/MaterialIcon";
import { Status } from "../../../components/shared/Status";
import { useAuth } from "../../../providers/AuthProvider";
import { ICohort } from "../../registries/models/Cohort";
import CohortCard from "./CohortCard";

interface IProps {
  isLoading: boolean;
  cohorts?: ICohort[];
  search?: string;
  setSearch: (search: string) => void;
  onClickCohort: (cohort: ICohort) => void;
  onEditCohort: (cohort: ICohort) => void;
  onDeleteCohort: (cohort: ICohort) => void;
}

const CohortGrid = ({
  isLoading,
  cohorts,
  search,
  setSearch,
  onClickCohort,
  onEditCohort,
  onDeleteCohort,
}: IProps) => {
  const [filteredCohorts, setFilteredCohorts] = React.useState<ICohort[]>(
    cohorts ? cohorts : []
  );

  const { userProfile } = useAuth();

  const handleOnClickCohort = (cohort: ICohort) => {
    onClickCohort(cohort);
  };

  const handleOnEditCohort = (cohort: ICohort) => {
    onEditCohort(cohort);
  };
  const handleOnDeleteCohort = (cohort: ICohort) => {
    onDeleteCohort(cohort);
  };

  const handleOnClearSearch = () => {
    setSearch("");
  };

  React.useEffect(() => {
    let filteredCohorts: ICohort[] = [];

    if (cohorts) {
      filteredCohorts = cohorts.filter((cohort) => {
        const regValue = cohort.title.toLowerCase();

        if (search && !regValue.includes(search)) {
          return false;
        }

        return true;
      });
    }

    setFilteredCohorts(filteredCohorts);
  }, [cohorts, search]);

  return (
    <Box>
      <Wrap spacing={{ base: 4, lg: 8 }}>
        {filteredCohorts.map((cohort) => (
          <WrapItem key={cohort.id} w="20rem">
            <CohortCard
              onOpen={() => {
                handleOnClickCohort(cohort);
              }}
              onEdit={
                userProfile.is_admin
                  ? () => {
                      handleOnEditCohort(cohort);
                    }
                  : undefined
              }
              onDelete={() => handleOnDeleteCohort(cohort)}
              cohort={cohort}
            ></CohortCard>
          </WrapItem>
        ))}
      </Wrap>

      {isLoading && <Status.IsLoading title="Loading"></Status.IsLoading>}

      {!isLoading && !search && !filteredCohorts.length && (
        <Status.NoData
          title="You don't have any cohorts"
          description="View a registry and select individual records to create a new cohort."
        ></Status.NoData>
      )}

      {!isLoading && search && !filteredCohorts.length && (
        <Status.NoResults
          title="No results"
          description={`We couldnt find any cohorts matching ${search}`}
        >
          <Center>
            <Button
              onClick={handleOnClearSearch}
              leftIcon={
                <MaterialIcon
                  name="backspace"
                  fontSize="1rem"
                  variant="outline"
                />
              }
            >
              Clear Seach
            </Button>
          </Center>
        </Status.NoResults>
      )}
    </Box>
  );
};

export default CohortGrid;
